import { BrowserSuggestion } from './BrowserSuggestion';
export default BrowserSuggestion;